import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableDiseaseFragment = { readonly __typename?: 'SyncableDisease', readonly id: string, readonly category: string, readonly catalogueCoding?: { readonly __typename?: 'DiseaseCatalogueCoding', readonly icd10?: { readonly __typename?: 'DiseaseSpecificationReference', readonly code: string, readonly system?: string | null } | null, readonly icd11?: { readonly __typename?: 'DiseaseSpecificationReference', readonly code: string, readonly system?: string | null } | null } | null, readonly i18n: ReadonlyArray<{ readonly __typename?: 'I18NSchema', readonly locale: Types.L10N, readonly categoryDisplayName: string, readonly displayName: string, readonly keywords?: ReadonlyArray<string> | null }>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncDiseasePullQueryVariables = Types.Exact<{
  input: Types.PullDiseaseInput;
}>;


export type SyncDiseasePullQuery = { readonly __typename?: 'Query', readonly pullDisease: { readonly __typename?: 'PullDiseaseResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableDisease', readonly id: string, readonly category: string, readonly catalogueCoding?: { readonly __typename?: 'DiseaseCatalogueCoding', readonly icd10?: { readonly __typename?: 'DiseaseSpecificationReference', readonly code: string, readonly system?: string | null } | null, readonly icd11?: { readonly __typename?: 'DiseaseSpecificationReference', readonly code: string, readonly system?: string | null } | null } | null, readonly i18n: ReadonlyArray<{ readonly __typename?: 'I18NSchema', readonly locale: Types.L10N, readonly categoryDisplayName: string, readonly displayName: string, readonly keywords?: ReadonlyArray<string> | null }>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableDiseaseFragmentDoc = gql`
    fragment WholeSyncableDisease on SyncableDisease {
  id
  category
  catalogueCoding {
    icd10 {
      code
      system
    }
    icd11 {
      code
      system
    }
  }
  i18n {
    locale
    categoryDisplayName
    displayName
    keywords
  }
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncDiseasePullDocument = gql`
    query SyncDiseasePull($input: PullDiseaseInput!) {
  pullDisease(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableDisease
    }
  }
}
    ${WholeSyncableDiseaseFragmentDoc}`;

/**
 * __useSyncDiseasePullQuery__
 *
 * To run a query within a React component, call `useSyncDiseasePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncDiseasePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncDiseasePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDiseasePullQuery(baseOptions: Apollo.QueryHookOptions<SyncDiseasePullQuery, SyncDiseasePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncDiseasePullQuery, SyncDiseasePullQueryVariables>(SyncDiseasePullDocument, options);
      }
export function useSyncDiseasePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncDiseasePullQuery, SyncDiseasePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncDiseasePullQuery, SyncDiseasePullQueryVariables>(SyncDiseasePullDocument, options);
        }
export type SyncDiseasePullQueryHookResult = ReturnType<typeof useSyncDiseasePullQuery>;
export type SyncDiseasePullLazyQueryHookResult = ReturnType<typeof useSyncDiseasePullLazyQuery>;
export type SyncDiseasePullQueryResult = Apollo.QueryResult<SyncDiseasePullQuery, SyncDiseasePullQueryVariables>;